import React from "react";

import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => {
  return {
    labelClass: (props) => ({
      fontSize: 14,
      fontWeight: 500,
      color: "rgba(54, 43, 115, 1)",
      opacity: 0.56,
      margin: theme.spacing(1.5, 0, 0),
      ...props?.styles?.labelClass,
    }),
    valueClass: (props) => ({
      fontSize: 32,
      fontWeight: 600,
      color: "rgba(54, 43, 115, 1)",
      margin: theme.spacing(1.5, 0, 0),
      ...props?.styles?.valueClass,
    }),
    subValueClass: (props) => ({
      fontSize: 18,
      fontWeight: 500,
      color: "rgba(54, 43, 115, 1)",
      margin: theme.spacing(0, 1.5),
      opacity: 0.56,
      ...props?.styles?.subValueClass,
    }),
    downloadLinkClass: (props) => ({
      fontSize: 14,
      fontWeight: 400,
      color: "rgba(226, 19, 110, 1)",
      margin: theme.spacing(0, 1.5),
      ...props?.styles?.downloadLinkClass,
      cursor: "pointer",
    }),
  };
});

export default function HeaderAndValue(props) {
  const classes = useStyle(props);
  const { label, value, subValue, downloadLink } = props;

  return (
    <>
      {label && <p className={classes.labelClass}>{label}</p>}
      <p className={classes.valueClass}>
        {value}
        {subValue && <span className={classes.subValueClass}>{subValue}</span>}
        {downloadLink && (
          <span className={classes.downloadLinkClass}>(Download List)</span>
        )}
      </p>
    </>
  );
}
